import { getTenantsList, getTenets } from "../../../api/tenets";
import icons from "../../../assets/icons/icons";
import { routes } from "../../../constants/routes";
import { ROLES, SUPER_TENANT } from "../../../utils/constants";
export interface Tenant {
  name: string | null;
  email: string | null;
  phone_number: string | null;
  created_at: string | null;
  status: "active" | "inactive" | null;
}

export interface TenentList {
  totalRecords: number | null;
  data: Tenant[];
}

export interface SortOption {
  sortDirection: string | null;
  sortBy: string | null;
}

export interface TenetListParams {
  limit: string | number;
  offset: string | number;
  sortDirection?: string | null;
  sortBy?: string | null;
  searchText?: string;
}

export interface ConfirmationPopupTypes {
  status: string | null;
  isOpen: boolean;
  partnerDetails: any;
  title: string;
  note: any;
  button: string;
  value?: string;
  updatedPartnerDataList?: any;
  buttonText?: string;
  Icon?: React.ReactNode;
  activePlan?: any;
}

export const confirmationDefaultValues = {
  status: null,
  isOpen: false,
  partnerDetails: null,
  title: "",
  note: "",
  button: "Ok",
};

export const breadcrumbLink = [
  {
    label: "Partner Management",
    link: "#",
    handleClick: () => {},
  },
  {
    label: "Partner List",
    link: routes.PARTNERLIST,
    handleClick: () => {},
  },
];

export const fetchUniqueCompanyNames = async (): Promise<string[]> => {
  try {
    const response = await getTenets({dropDown: true});
    const items = response?.data?.data?.data?.data || [];

    const seen = new Set<string>();
    const uniqueCompanyNames: string[] = [];

    for (const item of items) {
      if (item?.company_name && !seen.has(item.company_name)) {
        seen.add(item.company_name);
        uniqueCompanyNames.push(item.company_name);
      }
    }

    return uniqueCompanyNames;
  } catch (error) {
    console.error("Failed to fetch company names:", error);
    return [];
  }
};

export const fetchUniquePartnerNames = async (): Promise<string[]> => {
  try {
    const response = await getTenantsList({dropDown: true});
    const items = response?.data?.data?.data?.data || [];

    const seen = new Set<string>();
    const uniqueCompanyNames: string[] = [];

    for (const item of items) {
      if (item?.company_name && !seen.has(item.company_name)) {
        seen.add(item.company_name);
        uniqueCompanyNames.push(item.company_name);
      }
    }

    return uniqueCompanyNames;
  } catch (error) {
    console.error("Failed to fetch company names:", error);
    return [];
  }
};